<template>
  <b-container fluid>
    <b-row class="mt-3">
      <b-col>
        <b-card no-body>
          <b-tabs card>
            <b-tab title="Profile">
              <b-row>
                <b-col>
                  <b-button @click="showModal = true" variant="outline-secondary">Change Profile Image</b-button>
                  <hr />
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-form @submit.stop.prevent="onSubmit">
                    <b-form-group>
                      <b-form-group
                        label="Name"
                        label-for="name-input"
                        invalid-feedback="Name is required"
                      >
                        <b-form-input
                          id="name-input"
                          v-model="user.name"
                          required
                        ></b-form-input>
                      </b-form-group>
                    </b-form-group>

                    <b-form-group
                      label="Company"
                      label-for="company-input"
                    >
                      <b-form-input
                        id="company-input"
                        v-model="user.company"
                      ></b-form-input>
                    </b-form-group>

                    <b-form-group
                      label="Introduction"
                      label-for="introduction-input"
                    >
                      <b-form-textarea
                        id="introduction-input"
                        v-model="user.introduction"
                        rows="3"
                        maxRows="6"
                      ></b-form-textarea>
                    </b-form-group>

                    <b-button type="submit" variant="primary">Save</b-button>
                    <b-spinner v-if="saving" variant="primary"></b-spinner>
                  </b-form>
                </b-col>
              </b-row>
            </b-tab>
            <b-tab title="Change Password">
              <b-row>
                <b-col>
                  <b-form @submit.stop.prevent="onChangePassword">
                   <b-form-group
                    label="Password"
                    label-for="password-input"
                    >
                      <b-form-input
                        id="password-input"
                        type="password"
                        v-model="password"
                        required
                      ></b-form-input>
                    </b-form-group>

                    <b-form-group
                      label="Confirm Password"
                      label-for="confirm-password-input"
                      :invalid-feedback="changePasswordInvalidFeedback"
                      :valid-feedback="changePasswordValidFeedback"
                      :state="changePasswordState">
                      <b-form-input
                        id="confirm-password-input"
                        type="password"
                        v-model="confirmPassword"
                        :state="changePasswordState"
                        required
                      ></b-form-input>
                    </b-form-group>

                    <b-button type="submit" variant="primary">Save</b-button>
                    <b-spinner v-if="saving" variant="primary"></b-spinner>
                  </b-form>
                </b-col>
              </b-row>
            </b-tab>
          </b-tabs>
        </b-card>
      </b-col>
    </b-row>
    <b-modal v-model="showModal" title="Change Image" @ok="updateImage">
      <b-row>
        <b-col class="text-center">
          <b-spinner v-if="savingImage" variant="primary"></b-spinner>
          <image-uploader
            :preview="true"
            :className="['fileinput', { 'fileinput--loaded': hasImage }]"
            capture="environment"
            :debug="1"
            accept="image/png,image/jpeg"
            :maxWidth="192"
            doNotResize="gif"
            :autoRotate="true"
            outputFormat="verbose"
            @input="setImage">
            <label for="fileInput" slot="upload-label">
              <b-icon-camera></b-icon-camera>
              <h3>{{ hasImage ? 'Replace' : 'Select Profile Picture' }}</h3>
            </label>
          </image-uploader>
        </b-col>
      </b-row>
    </b-modal>
  </b-container>
</template>

<script>
import ImageUploader from 'vue-image-upload-resize'
import Api from '@/api/Api'

export default {
  data () {
    return {
      showModal: false,
      image: null,
      hasImage: false,
      savingImage: false,
      saving: false,
      user: {
        name: '',
        company: '',
        introduction: ''
      },
      password: '',
      confirmPassword: ''
    }
  },
  mounted () {
    this.user.name = this.$store.state.auth.currentUser.name
    this.user.company = this.$store.state.auth.currentUser.company
    this.user.introduction = this.$store.state.auth.currentUser.introduction
  },
  methods: {
    onSubmit (evt) {
      evt.preventDefault()
      var vm = this
      vm.saving = true
      const data = {
        name: vm.user.name,
        company: vm.user.company,
        introduction: vm.user.introduction,
        updatePassword: false
      }
      Api().put('User/Profile', data)
        .then((r) => {
          return this.$store.dispatch('auth/setCurrentUser', {
            ...r.data,
            token: this.$store.state.auth.currentUser.token
          })
        })
        .catch((e) => {
          if (e.response.status === 401) {
            this.$router.push({ name: 'Login' })
          } else {
            console.log(e)
          }
        })
        .finally(() => {
          vm.saving = false
        })
    },
    onChangePassword (evt) {
      evt.preventDefault()
      var vm = this

      if (!vm.password || vm.password !== vm.confirmPassword) {
        return
      }

      vm.saving = true
      const data = {
        name: this.$store.state.auth.currentUser.name,
        company: this.$store.state.auth.currentUser.company,
        introduction: this.$store.state.auth.currentUser.introduction,
        updatePassword: true,
        password: vm.password,
        confirmPassword: vm.confirmPassword
      }
      console.log(data)
      Api().put('User/Profile', data)
        .then((r) => {
          vm.password = ''
          vm.confirmPassword = ''
        })
        .catch((e) => {
          console.log(e)
        })
        .finally(() => {
          vm.saving = false
        })
    },
    updateImage () {
      var vm = this
      vm.savingImage = true
      fetch(vm.image.dataUrl)
        .then((res) => { return res.arrayBuffer() })
        .then((buf) => { return new File([ buf ], vm.image.info.name, { type: vm.image.type }) })
        .then((file) => {
          return this.$store.dispatch('profileImage/upload', file)
            .then(() => {
              vm.showModal = false
              vm.image = null
              vm.hasImage = false
            })
        })
        .catch((e) => {
          console.log(e)
        })
        .finally(() => {
          vm.savingImage = false
        })
    },
    setImage (result) {
      this.hasImage = true
      this.image = result
    }
  },
  components: {
    ImageUploader
  },
  computed: {
    changePasswordState () {
      return (this.password.length > 0) ? this.password === this.confirmPassword : null
    },
    changePasswordInvalidFeedback () {
      var vm = this
      if (vm.password !== null && vm.password !== '') {
        if (vm.password !== vm.confirmPassword) {
          return 'Passwords do not match'
        }
      }
      return null
    },
    changePasswordValidFeedback () {
      var vm = this
      if (vm.password) {
        if (vm.password === vm.confirmPassword) {
          return 'Passwords match!'
        }
      }
      return null
    }
  },
  watch: {
    showModal (value) {
      if (value) {
        this.image = null
        this.hasImage = null
      }
    }
  }
}
</script>

<style>
#fileInput {
  display: none;
}
</style>
